import Footer from "./small/Footer";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Link } from "react-router-dom";
const NftCollection = () => {
  const nftColleciton = [
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
  ];

  const nftCollecitonPop = [
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
    {
      image: "../../assets/images/NFTcollection/img1.png",
      profName: "Williams",
      nftCollectionTitle: "Genesis",
      profImage: "../../assets/images/NFTcollection/prof.png",
    },
  ];
  return (
    <>
      {/* <section>
        <img
          className="img-fluid"
          src="../../assets/images/NFTcollection/banner.png"
          alt=""
        />
      </section> */}

      <main className="collection-page-bg">
        <section className="collections">
          <div className="container">
            <h3 className="explore-collection-title">Explore Collection</h3>
          </div>
        </section>

        <section className="tabs">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <Tabs
                  defaultActiveKey="home"
                  id="fill-tab-example"
                  className="mb-3"
                  fill
                >
                  <Tab eventKey="home" title="Trending">
                    <div className="row">
                      {nftColleciton.map((item, index) => {
                        return (
                          <div className="col-sm-6 col-xl-3 col-lg-4">
                            <Link
                              to="/collectionexpand"
                              style={{ color: "transparent" }}
                            >
                              <div className="collection-card-wrapper">
                                <img
                                  className="img-fluid main-collection-img"
                                  src={item.image}
                                  alt=""
                                />

                                <div className="pattern row">
                                  <div className="one-c col-sm-4 col-4">
                                    <h5 className="c-tit">
                                      {item.nftCollectionTitle}
                                    </h5>
                                    <h6 className="prof-tit">
                                      By <span>{item.profName}</span>{" "}
                                      <img
                                        src="../../assets/images/icons/verified-icon.png"
                                        alt=""
                                        className="verif-icon-collection"
                                      />
                                    </h6>
                                  </div>
                                  <div className="two-c col-sm-4 col-4">
                                    <img
                                      className="img-fluid prof-img"
                                      src={item.profImage}
                                      alt=""
                                    />
                                  </div>
                                  <div className="three-c col-sm-4 col-4 text-end">
                                    <button className="follow-us">
                                      {" "}
                                      Follow
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </Tab>
                  <Tab eventKey="profile" title="Top" disabled>
                    2
                  </Tab>
                  <Tab eventKey="longer-tab" title="Art" disabled>
                    3
                  </Tab>
                  <Tab eventKey="contact" title="Collectibles" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Domain Names" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Photography" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Sports" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Tranding Cards" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Utility" disabled>
                    4
                  </Tab>
                  <Tab eventKey="contact" title="Virtual Words" disabled>
                    4
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </section>

        <section className="popular-collections pt-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="title">
                  <h2 className="main-tite nft-details-more-collection nft-collection">
                    <span> &#91;</span>More Collections <span> &#93;</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {nftCollecitonPop.map((item, index) => {
                return (
                  <div className="col-sm-6 col-xl-4 col-lg-4">
                    <div className="collection-card-wrapper">
                      <img
                        className="img-fluid main-collection-img"
                        src={item.image}
                        alt=""
                      />

                      <div className="pattern row">
                        <div className="one-c col-sm-4 col-4">
                          <h5 className="c-tit">{item.nftCollectionTitle}</h5>
                          <h6 className="prof-tit">
                            By <span>{item.profName}</span>{" "}
                            <img
                              src="../../assets/images/icons/verified-icon.png"
                              alt=""
                              className="verif-icon-collection"
                            />
                          </h6>
                        </div>
                        <div className="two-c col-sm-4 col-4">
                          <img
                            className="img-fluid prof-img"
                            src={item.profImage}
                            alt=""
                          />
                        </div>
                        <div className="three-c col-sm-4 col-4 text-end">
                          <button className="follow-us"> Follow</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};

export default NftCollection;
